/**
 * Cart Drawer Reservation Timer
 *
 * A dynamic countdown timer that persists across page loads using sessionStorage.
 * The timer resets when the cart drawer is opened with a fresh session.
 */
(function () {
  const STORAGE_KEY = 'cart_timer_end';

  function initTimer() {
    const timerEl = document.getElementById('cart-drawer-timer');
    const countdownEl = document.getElementById('cart-timer-countdown');

    if (!timerEl || !countdownEl) return;

    const minutes = parseInt(timerEl.dataset.minutes, 10) || 15;
    let endTime = null;

    // Check for existing timer in sessionStorage
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      const storedEnd = parseInt(stored, 10);
      if (storedEnd > Date.now()) {
        endTime = storedEnd;
      }
    }

    // If no valid timer exists, start a new one
    if (!endTime) {
      endTime = Date.now() + minutes * 60 * 1000;
      sessionStorage.setItem(STORAGE_KEY, endTime.toString());
    }

    let intervalId = null;

    function updateDisplay() {
      const remaining = Math.max(0, endTime - Date.now());
      const mins = Math.floor(remaining / 60000);
      const secs = Math.floor((remaining % 60000) / 1000);

      countdownEl.textContent =
        mins.toString().padStart(2, '0') + ':' + secs.toString().padStart(2, '0');

      if (remaining <= 0) {
        clearInterval(intervalId);
        // Restart timer when it expires
        endTime = Date.now() + minutes * 60 * 1000;
        sessionStorage.setItem(STORAGE_KEY, endTime.toString());
        intervalId = setInterval(updateDisplay, 1000);
      }
    }

    updateDisplay();
    intervalId = setInterval(updateDisplay, 1000);

    // Cleanup when element is removed from DOM
    const observer = new MutationObserver(function (mutations) {
      if (!document.contains(timerEl)) {
        clearInterval(intervalId);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Initialize when DOM is ready and also after cart drawer AJAX updates
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTimer);
  } else {
    initTimer();
  }

  // Re-initialize after section rendering (cart AJAX updates via morph)
  const originalMorphSection =
    window.__cartTimerInitialized;
  if (!window.__cartTimerInitialized) {
    window.__cartTimerInitialized = true;

    // Listen for dialog open events to reinitialize timer
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        // Small delay to let the dialog open and render
        setTimeout(initTimer, 100);
      }
    });

    // MutationObserver to detect when cart-drawer-timer appears in DOM
    const bodyObserver = new MutationObserver(function () {
      const timerEl = document.getElementById('cart-drawer-timer');
      const countdownEl = document.getElementById('cart-timer-countdown');
      if (timerEl && countdownEl && !timerEl.dataset.initialized) {
        timerEl.dataset.initialized = 'true';
        initTimer();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
